<template>
  <p class="d-lg-none">
    <b-button id="add-to-home-screen" variant="link" class="p-0">
      <i class="fa fa-fw fa-plus-square"></i>
      {{ trans('add_to_home_screen') }}
    </b-button>
    <b-popover
      target="add-to-home-screen"
      triggers="click blur"
      placement="bottom"
      :title="trans('add_to_home_screen')"
    >
      <p v-html="trans('add_to_home_screen_about')">
        {{ trans('template_edit_branding') }}
      </p>
    </b-popover>
  </p>
</template>

<script>
  export default {
    props: {
      organization: Object,
    },
    data() {
      return {
        trans: trans,
      }
    },
    computed: {
      showIcon() {
        // Only on iOS Safari
        let ua = window.navigator.userAgent
        let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
        let webkit = !!ua.match(/WebKit/i)
        return iOS && webkit && !ua.match(/CriOS/i)
      },
    },
    mounted() {
      window.addToHomeScreen = this
    },
  }
</script>